import type { ToolCall } from "./useAssistantChat";
import { assistantFiltersToRequestUrl } from "./assistantFiltersToRequestUrl";
import { assistantBriefingToOperationsUrl, assistantFiltersToOperationsUrl } from "./assistantFiltersToOperationsUrl";

export interface ToolCallLink {
  label: string;
  url: string;
}

interface LinkRule {
  tools: ReadonlySet<string>;
  label: string;
  toUrl: (input: unknown) => string | null;
}

const RULES: readonly LinkRule[] = [
  {
    tools: new Set(["get_request_list", "get_request_summary", "get_request_aggregate"]),
    label: "View these in the grid",
    toUrl: assistantFiltersToRequestUrl,
  },
  {
    tools: new Set(["get_operations_summary", "get_operations_items", "get_operations_journeys"]),
    label: "Show on the dashboard",
    toUrl: assistantFiltersToOperationsUrl,
  },
  {
    // The briefing's list, and the group a drivers answer diagnosed: the journey drawer on its open journeys.
    tools: new Set(["get_briefing", "explain_drivers"]),
    label: "Show these on the dashboard",
    toUrl: assistantBriefingToOperationsUrl,
  },
];

/**
 * The link an assistant answer can offer back into the app, from the message's most recent tool
 * call that has a screen to land on: the Request List for the request tools, the Operations
 * dashboard for the Operations tools. Null when no call maps.
 */
export function toolCallLink(toolCalls: ToolCall[]): ToolCallLink | null {
  for (const call of [...toolCalls].reverse()) {
    const rule = RULES.find((r) => r.tools.has(call.name));
    if (!rule) continue;
    try {
      const url = rule.toUrl(JSON.parse(call.input));
      return url ? { label: rule.label, url } : null;
    } catch {
      return null;
    }
  }
  return null;
}
